<template>
	<div>
		<div class="colonn">
			<div style="height: 80px;"></div>
			<div class="roww rowsa">
				<div style="width: 100px;"></div>
				<div class="colonn  animate__animated animate__slideInUp" style="margin-left: 100px;">
					<div class="roww duiqi">
						<div style="font-size: 30px;color: brown;">联系我们</div>
						<div style="width: 20px;"></div>
						<div style="color: rgb(165, 165, 165);">CONCACT US</div>
					</div>
					<div style="height: 100px;"></div>
					<div class="colonn">
						<div class="roww lianxi">
							<img src="https://shandongtibohui.zsyflive.com/profile/xd/ruier/gongzhong/20201221092853779.png"
								class="lefticon" />
							<div>公司地址：山东省济南市历下区泉城路26号世茂广场A座9楼</div>
						</div>
						<div class="roww  lianxi">
							<img src="https://shandongtibohui.zsyflive.com/profile/xd/ruier/gongzhong/20201221092907780.png"
								class="lefticon" />
							<div>联系电话：0531-86160666</div>
						</div>
						<div class="roww  lianxi">
							<img src="https://shandongtibohui.zsyflive.com/profile/xd/ruier/gongzhong/2020122109293013.png"
								class="lefticon" />
							<div>电子邮箱：12356ab@163.com </div>
						</div>
					</div>
				</div>

				<div style="width: 700px;height: 700px;" class=" animate__animated animate__slideInUp">
					<iframe width="800" height="460" frameborder='0' scrolling='no' marginheight='0' marginwidth='0'
						src="https://surl.amap.com/bnNqn91168bU"></iframe>
				</div>

				<div style="width: 100px;"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ComponentName', // 组件的名称
		components: {

		},

		data() {
			return {

			}
		},

		props: {
			// 组件的属性
		},

		computed: {
			// 组件的计算属性
		},

		methods: {

		},

		mounted() {
			// 组件挂载后的操作
		},

	}
</script>

<style>
	@import url(lianxiwomen.css);
</style>